<template>
  <div>
    <v-card>
      <v-card-title primary-title>
        <h3>Điều phối nhanh</h3>
      </v-card-title>
      <v-card-text>
        <v-text-field
          prepend-inner-icon="location_on"
          v-model="location"
          label="Tọa độ điểm lắp đặt"
          class="mt-0"
        ></v-text-field>
        <v-switch label="Khách yêu cầu thời gian lắp đặt" v-model="hasTime" color="primary"></v-switch>
        <v-text-field
          prepend-inner-icon="access_time"
          v-model="time"
          label="Thời gian lắp đặt"
          v-show="hasTime"
        ></v-text-field>
        <v-btn outline round block color="primary" dark @click="dispatch()">Kiểm tra lịch trống</v-btn>
      </v-card-text>
    </v-card>
    <!-- Dialog -->
    <div class="text-xs-center">
      <v-dialog v-model="isDispatching" fullscreen lazy scrollable>
        <v-card>
          <div v-if="isDispatching">
            <overview
              :selectedCase="newCase"
              :supporters="supporters"
              @display="hideDispatch($event)"
            />
          </div>
        </v-card>
      </v-dialog>
    </div>
    <!-- End Dialog -->
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Overview from '@/pages/dispatch/Overview';
import moment from 'moment';

export default {
  components: {
    Overview
  },
  data () {
    return {
      isDispatching: false,
      newCase: {},
      location: '',
      time: moment().format('YYYY-MM-DD HH:mm'),
      hasTime: false,
      tab: null
    };
  },
  computed: {
    ...mapGetters(['supporters'])
  },
  methods: {
    ...mapMutations(['SET_SELECTED_CASES']),
    dispatch () {
      this.newCase['Location'] = this.location;
      this.newCase['CaseNumber'] = 'Quick Dispatch';
      this.newCase['InstallationDuration'] = 40;

      if (this.hasTime) this.newCase['Plan'] = moment(this.time).add(-7, 'hours').format('YYYY-MM-DD HH:mm');
      this.SET_SELECTED_CASES(this.newCase);
      this.isDispatching = true;
    },
    hideDispatch (isShow) {
      this.isDispatching = isShow;
      this.$emit('display', false);
    },
  }
};
</script>

<style lang="stylus"></style>


// WEBPACK FOOTER //
// src/pages/dispatch/components/QuickDispatch.vue